import React, { useRef, useEffect, useState } from "react";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../NavBars/ActionToolbar";
import SherComboBox from "../../ComboBoxes/SherComboBox";
import ssLogo from "../../../assets/images/sslogo.png";
import axios from "axios";
import { useDbContext } from "../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";

// Icon imports for the table area
import { FiSearch, FiFilter, FiFileText, FiGrid } from "react-icons/fi";

function FormRegistration({ onClose, zIndex }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const permissions = useSelector(selectMenuPermissions);

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);

  const nameInputRef = useRef(null);
  const TypeOfVoucherRef = useRef(null);
  const abbrInputRef = useRef(null);
  const agentRef = useRef(null);
  const saveButtonRef = useRef(null);

  const [tableData, setTableData] = useState([]);
  const [agentName, setagentName] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  
  const [formData, setFormData] = useState({
    slno: "",
    name: "",
    typeOfVoucher: "",
    abbr: "",
    agent: "",
    sms: 0,
    grate: 0,
  });

  const typeofVoucherOptions = [
    { label: "RECEIPT", value: "RECEIPT" },
    { label: "REDEEM", value: "REDEEM" },
    { label: "SCHEME RECEIPT", value: "SCHEME RECEIPT" },
    { label: "SCHEME REDEEM", value: "SCHEME REDEEM" },
  ];

  // Fetch all registrations for grid list
  const fetchData = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getformregdatas/${dbCode}`
      );
      setTableData(response.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch Salesman/Agent Names for Combobox
  const fetchAgname = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`
      );
      const transformedData = (response.data || []).map((item) => ({
        label: item.Name,
        value: item.Auto,
      }));
      setagentName(transformedData);
    } catch (error) {
      console.error("Error fetching agent values:", error.message);
    }
  };

  // Fetch next Serial Number/Entry Number
  const fetchEno = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/formregEntryno/${dbCode}`
      );
      setFormData((item) => ({
        ...item,
        slno: response.data,
      }));
    } catch (error) {
      console.error("Error fetching entryno:", error);
    }
  };

  useEffect(() => {
    if (dbCode) {
      fetchData();
      fetchAgname();
      fetchEno();
    }
  }, [dbCode]);

  useEffect(() => {
    setTimeout(() => {
      nameInputRef.current?.focus?.();
    }, 150);
  }, []);

  const handleClear = () => {
    setFormData({
      slno: "",
      name: "",
      typeOfVoucher: "",
      abbr: "",
      agent: "",
      sms: 0,
      grate: 0,
    });
    fetchEno();
    fetchData();
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setTimeout(() => {
      nameInputRef.current?.focus?.();
    }, 100);
  };

  const resolveAgentId = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    if (typeof val === "object") {
      val = val.value !== undefined ? val.value : val.label;
    }
    const num = Number(val);
    if (!isNaN(num) && num > 0) return num;

    const str = String(val).trim().toLowerCase();
    const matched = agentName.find(
      (a) =>
        String(a.label || "").trim().toLowerCase() === str ||
        String(a.value || "").trim().toLowerCase() === str
    );
    if (matched && matched.value) {
      return Number(matched.value) || 0;
    }
    return 0;
  };

  const handleSelectRecord = (record) => {
    setEditDisabled(false);
    setDeleteDisabled(false);
    setSaveDisabled(true);
    setFormData({
      slno: record.fmrEntryNo,
      name: record.fmrName || "",
      typeOfVoucher: record.fmrTypeOfVoucher || "",
      abbr: record.fmrAbbreviation || "",
      agent: record.fmrAgentId || record.fmrSalesman || "",
      sms: record.fmrSMS || 0,
      grate: record.fmrGoldRate || 0,
    });
  };

  const handleSubmit = async () => {
    const resolvedAgent = resolveAgentId(formData.agent);
    if (
      !formData.name ||
      !formData.typeOfVoucher ||
      !formData.abbr ||
      !resolvedAgent ||
      !formData.slno
    ) {
      alert("Please fill all required fields correctly (including Salesman).");
      return;
    }

    setSaveDisabled(true);
    try {
      const payload = {
        ...formData,
        agent: resolvedAgent,
      };
      const response = await axios.post(
        `${apiBaseUrl}/main/insertformReg/${dbCode}`,
        payload
      );

      if (response.status === 200) {
        alert("Form Registered Successfully!");
        handleClear();
      } else {
        alert("Failed to register form.");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      alert("Error saving record: " + error.message);
      setSaveDisabled(false);
    }
  };

  const handleUpdate = async () => {
    const resolvedAgent = resolveAgentId(formData.agent);
    if (
      !formData.name ||
      !formData.typeOfVoucher ||
      !formData.abbr ||
      !resolvedAgent ||
      !formData.slno
    ) {
      alert("Please fill all required fields correctly (including Salesman).");
      return;
    }

    if (!window.confirm("Do you want to edit this entry?")) {
      return;
    }

    try {
      const payload = {
        ...formData,
        agent: resolvedAgent,
      };
      const response = await axios.post(
        `${apiBaseUrl}/main/updateformReg/${dbCode}`,
        payload
      );

      if (response.status === 200) {
        alert("Form Updated Successfully!");
        handleClear();
      } else {
        alert("Failed to update form.");
      }
    } catch (error) {
      console.error("Error updating form:", error.message);
      alert("Error: " + error.message);
    }
  };

  const handleDelete = async () => {
    if (!formData.slno) return;
    if (!window.confirm("Are you sure you want to delete this form?")) {
      return;
    }

    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deleteform/${formData.slno}/${dbCode}`
      );
      if (response.status === 200) {
        alert("Form Deleted Successfully!");
        handleClear();
      } else {
        alert("Failed to delete form.");
      }
    } catch (error) {
      console.error("Error:", error.message);
      alert("Error: " + error.message);
    }
  };

  const [showFindDialog, setShowFindDialog] = useState(false);
  const [findEntryNo, setFindEntryNo] = useState("");

  const handleFind = async () => {
    if (!findEntryNo) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/formregfindbyentryno/${findEntryNo}/${dbCode}`
      );

      if (response.status === 200 && response.data && response.data.length > 0) {
        const foundData = response.data[0];
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);

        setFormData({
          slno: foundData.entry,
          name: foundData.name || "",
          typeOfVoucher: foundData.voucher || "",
          abbr: foundData.abbr || "",
          agent: foundData.agent || "",
          sms: foundData.sms || 0,
          grate: foundData.grate || 0,
        });
        setShowFindDialog(false);
        setFindEntryNo("");
      } else {
        alert("No record found with this SlNo.");
      }
    } catch (error) {
      console.error("Error finding record:", error.message);
      alert("Error retrieving data.");
    }
  };

  const handleKeyDown = (event, nextInputRef) => {
    if (event.key === "Enter" || event.key === "Return") {
      event.preventDefault();
      nextInputRef?.current?.focus?.();
    }
  };

  // Checkbox handlers
  const handleSmsChange = (e) => {
    setFormData({
      ...formData,
      sms: e.target.checked ? 1 : 0,
    });
  };

  const handleGrateChange = (e) => {
    setFormData({
      ...formData,
      grate: e.target.checked ? 1 : 0,
    });
  };

  // Filter existing list
  const filteredTableData = tableData.filter((row) => {
    if (!searchQuery.trim()) return true;
    const needle = searchQuery.toLowerCase().trim();
    return (
      (row.fmrName && row.fmrName.toLowerCase().includes(needle)) ||
      (row.fmrAbbreviation && row.fmrAbbreviation.toLowerCase().includes(needle)) ||
      (row.fmrTypeOfVoucher && row.fmrTypeOfVoucher.toLowerCase().includes(needle))
    );
  });

  const updateNavRefs = (refs) => {
    if (refs.saveButtonRef) {
      saveButtonRef.current = refs.saveButtonRef.current;
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-3 font-Inter select-none"
      style={{ zIndex: zIndex || 101 }}
    >
      <div className="bg-white font-normal w-[940px] max-w-[98vw] h-auto rounded-xl shadow-2xl flex flex-col overflow-hidden border border-slate-200 box-border">
        {/* Window Header */}
        <WindowHeader
          title="Form Registration"
          logo={ssLogo}
          onClose={onClose}
          className="!h-8 bg-[#1e40af] text-white font-Inter"
          titleClassName="!text-xs"
          closeBtnClassName="h-5 w-5 my-auto mr-1 bg-red-600 hover:bg-red-700 rounded-sm flex items-center justify-center text-white"
        />

        {/* Toolbar */}
        <div className="w-full flex-shrink-0">
          <ActionToolbar
            width="100%"
            height="auto"
            bgColor="#EAF0FC"
            size="small"
            iconSize={16}
            showSave={permissions?.["formRegistration"]?.actions?.Save !== false}
            showPrint={false}
            showClear={true}
            showFind={permissions?.["formRegistration"]?.actions?.Find !== false}
            showEdit={permissions?.["formRegistration"]?.actions?.Edit !== false}
            showDelete={permissions?.["formRegistration"]?.actions?.Delete !== false}
            showExit={true}
            showNavigation={false}
            saveDisabled={formData.slno && editDisabled ? false : saveDisabled}
            editDisabled={editDisabled}
            deleteDisabled={deleteDisabled}
            dataFound={!editDisabled}
            onSave={editDisabled ? handleSubmit : handleUpdate}
            onClear={handleClear}
            onFind={() => setShowFindDialog(true)}
            onEdit={handleUpdate}
            onDelete={handleDelete}
            onExit={onClose}
            onRefsUpdate={updateNavRefs}
          />
        </div>

        {/* Main Content Body */}
        <div className="w-full flex-1 p-4 pb-5 bg-[#f0f4f9] flex flex-col lg:flex-row gap-4 items-stretch min-h-0 overflow-y-auto">
          
          {/* LEFT COLUMN: Add / Edit Form */}
          <div className="flex-1 w-full bg-white p-4 rounded-2xl border border-slate-200/80 shadow-xs flex flex-col gap-3">
            <h3 className="text-[11px] font-extrabold text-[#0a3899] uppercase tracking-wider m-0 pb-1.5 border-b border-slate-100 flex items-center gap-2 font-Inter">
              <FiFileText className="text-sm" />
              <span>Form Details</span>
            </h3>

            {/* SlNo */}
            <div className="flex items-center gap-3">
              <label className="w-[130px] text-xs font-bold text-slate-600 font-Inter">
                SlNo
              </label>
              <input
                type="text"
                value={formData.slno}
                readOnly
                className="w-28 h-9 text-center text-xs font-extrabold bg-slate-100/80 border border-slate-200 rounded-lg outline-none text-slate-700 shadow-2xs font-mono font-Inter"
              />
            </div>

            {/* Form Name */}
            <div className="flex items-center gap-3">
              <label className="w-[130px] text-xs font-bold text-slate-600 font-Inter">
                Form Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                ref={nameInputRef}
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                onKeyDown={(e) => handleKeyDown(e, TypeOfVoucherRef)}
                placeholder="Enter form name..."
                className="flex-1 h-9 px-3 text-xs font-medium border border-slate-200 rounded-lg outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600/20 bg-white hover:border-slate-300 transition-all font-Inter"
              />
            </div>

            {/* Type of Voucher */}
            <div className="flex items-center gap-3">
              <label className="w-[130px] text-xs font-bold text-slate-600 font-Inter">
                Type of Voucher <span className="text-red-500">*</span>
              </label>
              <div className="flex-1">
                <SherComboBox
                  comboRef={TypeOfVoucherRef}
                  options={typeofVoucherOptions}
                  value={formData.typeOfVoucher}
                  onSelect={(opt) => {
                    setFormData((prev) => ({ ...prev, typeOfVoucher: opt.value }));
                  }}
                  onInputChange={(text) => {
                    setFormData((prev) => ({ ...prev, typeOfVoucher: text }));
                  }}
                  placeholder="Select voucher type..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-slate-200 rounded-lg focus:border-blue-600 shadow-2xs text-xs pl-3 font-medium hover:border-slate-300 transition-all bg-white font-Inter"
                  inputStyle={{}}
                  onKeyDown={(e) => handleKeyDown(e, abbrInputRef)}
                />
              </div>
            </div>

            {/* Abbreviation */}
            <div className="flex items-center gap-3">
              <label className="w-[130px] text-xs font-bold text-slate-600 font-Inter">
                Abbreviation <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                ref={abbrInputRef}
                value={formData.abbr}
                onChange={(e) => setFormData({ ...formData, abbr: e.target.value })}
                onKeyDown={(e) => handleKeyDown(e, agentRef)}
                placeholder="Enter abbreviation..."
                className="flex-1 h-9 px-3 text-xs font-medium border border-slate-200 rounded-lg outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600/20 bg-white hover:border-slate-300 transition-all font-Inter"
              />
            </div>

            {/* Salesman */}
            <div className="flex items-center gap-3">
              <label className="w-[130px] text-xs font-bold text-slate-600 font-Inter">
                Salesman <span className="text-red-500">*</span>
              </label>
              <div className="flex-1">
                <SherComboBox
                  comboRef={agentRef}
                  options={agentName}
                  value={formData.agent}
                  onSelect={(opt) => {
                    setFormData((prev) => ({ ...prev, agent: opt ? opt.value : "" }));
                  }}
                  onInputChange={(text) => {
                    setFormData((prev) => {
                      const matched = agentName.find(
                        (a) => String(a.label || "").trim().toLowerCase() === String(text || "").trim().toLowerCase()
                      );
                      return { ...prev, agent: matched ? matched.value : text };
                    });
                  }}
                  placeholder="Enter salesman name..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-slate-200 rounded-lg focus:border-blue-600 shadow-2xs text-xs pl-3 font-medium hover:border-slate-300 transition-all bg-white font-Inter"
                  inputStyle={{}}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === "Return") {
                      setTimeout(() => {
                        editDisabled ? handleSubmit() : handleUpdate();
                      }, 50);
                    }
                  }}
                />
              </div>
            </div>

            {/* Checkboxes (SMS / Gold Rate) */}
            <div className="flex items-center gap-8 pl-[130px] mt-1.5">
              <label className="flex items-center gap-2 text-xs font-bold text-slate-600 cursor-pointer font-Inter">
                <input
                  type="checkbox"
                  checked={formData.sms === 1}
                  onChange={handleSmsChange}
                  className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 w-4 h-4 cursor-pointer"
                />
                SMS
              </label>
              <label className="flex items-center gap-2 text-xs font-bold text-slate-600 cursor-pointer font-Inter">
                <input
                  type="checkbox"
                  checked={formData.grate === 1}
                  onChange={handleGrateChange}
                  className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 w-4 h-4 cursor-pointer"
                />
                Gold Rate
              </label>
            </div>

            {/* Save / Update Action Button */}
            <button
              type="button"
              onClick={editDisabled ? handleSubmit : handleUpdate}
              className="w-full mt-2 py-1.5 px-3 bg-[#1e40af] hover:bg-blue-800 active:scale-[0.99] text-white font-bold text-xs rounded-lg shadow-sm transition-all cursor-pointer flex items-center justify-center gap-2 font-Inter"
            >
              <span>{editDisabled ? "Save Registration" : "Update Registration"}</span>
            </button>
          </div>

          {/* RIGHT COLUMN: Registered Forms (mockup styled table area) */}
          <div className="w-full lg:w-[480px] shrink-0 bg-white p-4 rounded-2xl border border-slate-200 shadow-xs flex flex-col gap-3 box-border">
            
            {/* Header */}
            <div className="flex items-center gap-2 text-[#0a3899] font-bold text-xs uppercase tracking-wider pb-1.5 border-b border-slate-100 font-Inter">
              <FiFileText className="text-sm" />
              <span>Registered Forms</span>
            </div>

            {/* Search and Filter Row */}
            <div className="flex items-center gap-2">
              <div className="relative flex-1 flex items-center">
                <FiSearch className="absolute left-3 text-slate-400 text-sm" />
                <input
                  type="text"
                  placeholder="Search by form name or abbreviation..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full h-9 pl-9 pr-4 text-xs border border-slate-200 rounded-lg outline-none focus:border-blue-600 bg-slate-50/20 hover:bg-slate-50/50 transition-all font-medium placeholder-slate-400 font-Inter"
                />
              </div>
              <button className="w-9 h-9 rounded-lg border border-blue-600/20 bg-blue-50/40 text-blue-600 flex items-center justify-center hover:bg-blue-50 active:scale-95 transition-all">
                <FiFilter className="text-sm" />
              </button>
            </div>

            {/* Scrollable Table View Container */}
            <div className="overflow-auto rounded-lg border border-slate-300 shadow-xs max-h-[220px] report-scroll">
              <table className="min-w-full w-max text-left border-collapse text-xs font-Inter">
                <thead className="bg-[#0f56d3] text-white sticky top-0 font-semibold z-20">
                  <tr className="h-8">
                    <th className="py-1.5 px-3 font-semibold text-xs border-r border-blue-400/40 text-center bg-[#0f56d3] min-w-[60px] whitespace-nowrap">
                      Sl No
                    </th>
                    <th className="py-1.5 px-3 font-semibold text-xs border-r border-blue-400/40 bg-[#0f56d3] min-w-[160px] whitespace-nowrap">
                      Form Name
                    </th>
                    <th className="py-1.5 px-3 font-semibold text-xs border-r border-blue-400/40 bg-[#0f56d3] min-w-[160px] whitespace-nowrap">
                      Abbreviation
                    </th>
                    <th className="py-1.5 px-3 font-semibold text-xs bg-[#0f56d3] min-w-[140px] whitespace-nowrap">
                      Type Of Voucher
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 font-medium text-slate-800">
                  {filteredTableData.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="py-8 text-center text-xs text-slate-400 italic bg-white">
                        No forms registered
                      </td>
                    </tr>
                  ) : (
                    filteredTableData.map((row, idx) => {
                      const isSelected = String(row.fmrEntryNo) === String(formData.slno);
                      const rowBg = isSelected
                        ? "bg-blue-50/90"
                        : idx % 2 === 0
                        ? "bg-[#f7f7f7]"
                        : "bg-[#eeeeee]";

                      return (
                        <tr
                          key={row.fmrEntryNo}
                          onClick={() => handleSelectRecord(row)}
                          className={`h-8 border-b border-gray-300 hover:bg-blue-50/40 transition-colors duration-150 cursor-pointer ${rowBg}`}
                        >
                          <td className="py-1.5 px-3 text-center border-r border-gray-200 font-mono font-bold text-slate-700 whitespace-nowrap animate-fade-in">
                            {row.fmrEntryNo}
                          </td>
                          <td className="py-1.5 px-3 border-r border-gray-200 font-semibold text-slate-850 whitespace-nowrap">
                            {row.fmrName}
                          </td>
                          <td className="py-1.5 px-3 border-r border-gray-200 font-mono text-slate-700 whitespace-nowrap">
                            {row.fmrAbbreviation}
                          </td>
                          <td className="py-1.5 px-3 text-slate-500 font-mono whitespace-nowrap">
                            {row.fmrTypeOfVoucher}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Bottom Status Info */}
            <div className="flex items-center justify-between mt-1 shrink-0">
              <span className="text-[11px] font-bold text-slate-500 font-Inter">
                Total Records : {filteredTableData.length}
              </span>
            </div>
          </div>
        </div>

        {/* Find Dialog Popup (Premium Mockup Layout) */}
        {showFindDialog && (
          <div className="fixed inset-0 flex items-center justify-center bg-slate-900/55 z-[10000] backdrop-blur-2xs animate-fade-in font-Inter">
            <div className="bg-white p-4 rounded-xl shadow-2xl w-[360px] flex flex-col gap-4 border border-slate-100 relative overflow-hidden">
              
              {/* Dotted wave pattern overlay on bottom left */}
              <div className="absolute bottom-0 left-0 pointer-events-none opacity-20 select-none">
                <svg width="150" height="100" viewBox="0 0 150 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M-20,120 Q30,60 80,120 T180,120" stroke="#1e40af" strokeWidth="2" strokeDasharray="3 6" />
                  <path d="M-20,130 Q30,70 80,130 T180,130" stroke="#1e40af" strokeWidth="2" strokeDasharray="3 6" opacity="0.7" />
                  <path d="M-20,140 Q30,80 80,140 T180,140" stroke="#1e40af" strokeWidth="2" strokeDasharray="3 6" opacity="0.4" />
                </svg>
              </div>

              {/* Close Button Row */}
              <div className="flex justify-end w-full">
                <button
                  onClick={() => {
                    setShowFindDialog(false);
                    setFindEntryNo("");
                  }}
                  className="w-6 h-6 rounded-sm bg-red-600 hover:bg-red-700 text-white flex items-center justify-center transition-colors active:scale-95 cursor-pointer"
                >
                  <svg
                    className="w-3 h-3 fill-current"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7a1 1 0 10-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 001.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.41z"
                    />
                  </svg>
                </button>
              </div>

              {/* Input field (Full width row) */}
              <div className="relative flex items-center w-full">
                <input
                  type="text"
                  value={findEntryNo}
                  onChange={(e) => setFindEntryNo(e.target.value)}
                  placeholder="Enter entry number..."
                  className="w-full h-9 px-3 pr-10 text-xs border border-blue-400 focus:border-blue-600 bg-white rounded-lg outline-none focus:ring-1 focus:ring-blue-500/20 text-slate-850 font-Inter font-semibold placeholder-slate-350"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleFind();
                  }}
                  autoFocus
                />
                <FiGrid className="absolute right-3 text-slate-455 text-xs pointer-events-none" />
              </div>

              {/* Bottom buttons */}
              <div className="flex justify-end gap-2 pt-0.5 z-10">
                <button
                  onClick={() => {
                    setShowFindDialog(false);
                    setFindEntryNo("");
                  }}
                  className="px-4 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-bold rounded-lg transition-all cursor-pointer font-Inter active:scale-95"
                >
                  Cancel
                </button>
                <button
                  onClick={handleFind}
                  className="px-5 py-1.5 bg-[#1e40af] hover:bg-blue-800 text-white text-xs font-bold rounded-lg transition-all cursor-pointer flex items-center gap-1.5 active:scale-95 shadow-md font-Inter"
                >
                  <FiSearch className="text-xs" />
                  <span>Find</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FormRegistration;
